// extracted by mini-css-extract-plugin
export default {"title":"ForgotPassword_title__C8qPf","body":"ForgotPassword_body__bB4DP","goBack":"ForgotPassword_goBack__9pnwh","form":"ForgotPassword_form__-1Ebh"};